import { useTranslation } from "react-i18next";

import { faTrash } from "@fortawesome/pro-solid-svg-icons";

import { Modal } from "./Modal";
import { Icon } from "../Icon/Icon";

interface DeleteModalProps {
	isShowing: boolean;
	handleDelete: () => void;
	handleClose: () => void;
	title: string;
	description: string;
	isLoading?: boolean;
}

export default function DeleteModal({
	isShowing,
	handleDelete,
	handleClose,
	description,
	title,
	isLoading,
}: DeleteModalProps) {
	const { t } = useTranslation();

	return (
		<Modal
			aboveHeader={<Icon className="w-4 h-4" icon={faTrash} />}
			dialogContentClassName="!p-0"
			handleClose={handleClose}
			handleSave={handleDelete}
			isLoading={isLoading}
			isOpened={isShowing}
			saveButtonClassName="!h-[44px]"
			submitButtonColor="error"
			submitButtonText={t("basics.delete")}
			subtitle={description}
			title={title}
		>
			<div></div>
		</Modal>
	);
}
